"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateStripeCustomerDetailResponseSchema = exports.GetStripeCustomerDetailResponseSchema = exports.UpdateStripeCustomerDetailBodySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
exports.UpdateStripeCustomerDetailBodySchema = (0, core_1.StrictObject)({
    name: typebox_1.Type.Optional(typebox_1.Type.String()),
    phone: typebox_1.Type.Optional(typebox_1.Type.String()),
    email: typebox_1.Type.Optional(typebox_1.Type.String()),
    tax: (0, core_1.OptionalNullable)(typebox_1.Type.Array((0, core_1.StrictObject)({
        type: typebox_1.Type.String(),
        value: typebox_1.Type.String(),
    }))),
    address: typebox_1.Type.Optional((0, core_1.StrictObject)({
        line1: typebox_1.Type.String({ default: "" }),
        line2: typebox_1.Type.String({ default: "" }),
        city: typebox_1.Type.String(),
        state: typebox_1.Type.String(),
        postalCode: typebox_1.Type.String({ default: "" }),
        country: typebox_1.Type.String(),
    })),
});
exports.GetStripeCustomerDetailResponseSchema = (0, core_1.StrictObject)({
    name: typebox_1.Type.String(),
    phone: typebox_1.Type.String(),
    email: typebox_1.Type.String(),
    tax: typebox_1.Type.Optional(typebox_1.Type.Array((0, core_1.StrictObject)({
        type: typebox_1.Type.String(),
        value: typebox_1.Type.String(),
    }))),
    address: typebox_1.Type.Optional((0, core_1.StrictObject)({
        line1: typebox_1.Type.String(),
        line2: typebox_1.Type.String(),
        state: typebox_1.Type.String(),
        city: typebox_1.Type.String(),
        postalCode: typebox_1.Type.String(),
        country: typebox_1.Type.String(),
    })),
});
exports.UpdateStripeCustomerDetailResponseSchema = exports.GetStripeCustomerDetailResponseSchema;
